import axios from "axios";
import { message as AntdAlert } from "antd";
import { put, select } from "redux-saga/effects";
import * as actions from "../actions";
import { baseURL } from "../../../../globalUtils/axiosConfig";
import errorHandler from "../../../../components/unauthorizeHandler";


export function* handleFetchWarehouses() {
  try {
    const response = yield axios.get(`${baseURL}/lab-setup/warehouse-options`);

    if (response.status === 200 && response.data.success) {
      console.log('Raw warehouse data sample:', response.data.warehouses.slice(0, 3));
      const warehouses = response.data.warehouses.map(warehouse => ({
        id: warehouse.id,
        warehouse: warehouse.warehouse,
        labName: `${warehouse.warehouse} - ${warehouse.description || 'No Description'}`,
        wareHouseId: warehouse.id,
        branchCode: warehouse.branchcode,
        activeOnOmni: warehouse.isactve === 'Y', 
      }));

      yield put(actions.fetchWarehousesSuccess(warehouses));
    } else {
      yield put(actions.fetchWarehousesError());
      errorHandler(response.data);
    }
  } catch (error) {
    console.log('Error fetching warehouses:', error);
    yield put(actions.fetchWarehousesError());
  }
}
export function* handleCreateLab({ data }) {

  try {
    const fd = new FormData();
    for (const [key, value] of Object.entries(data)) {
      if (key === "documents" && value !== undefined) {
        if (Array.isArray(value)) {
          value.forEach(file => {
            fd.append('documents', file);
          });
        } else if (value) {
          fd.append('documents', value);
        }
        continue;
      }

      if (value && value._isAMomentObject) {
        fd.append(key, value.format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z');
      }
      else if (value !== null && value !== undefined) {
        fd.append(key, value);
      }
    }
    for (const pair of fd.entries()) {
      if (pair[1] instanceof File) {
        console.log(`${pair[0]}: File - ${pair[1].name} (${pair[1].type}, ${pair[1].size} bytes)`);
      } else {
        console.log(`${pair[0]}: ${pair[1]}`);
      }
    }

    const response = yield axios.post(`${baseURL}/lab-setup`, fd, {
      headers: {
        "content-type": "multipart/form-data",
      },
    });

    if (response.status === 201) {
      AntdAlert.success("Lab created successfully");
      yield put(actions.createLabSuccess(response.data));
    } else if (response.status !== 201) {
      AntdAlert.error("Something went wrong!");
      yield put(actions.createLabError());
      errorHandler(response.data);
    }
  } catch (error) {
    console.log(error);
    yield put(actions.createLabError());
  }
}

export function* handleUpdateLab({ data }) {
  console.log("handleUpdateLab", data);

  try {
    const labId = data.id;
    const formData = new FormData();

    for (const [key, value] of Object.entries(data)) {
      if (key === "id") {
        continue;
      }
      else if (key === "documents") {
        if (value && Array.isArray(value)) {
          value.forEach(file => {
            if (file.isLocal) {
              formData.append('documents', file);
            }
          });
        }
      }
      else if (value && value._isAMomentObject) {
        formData.append(key, value.format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z');
      }
      else if (key === 'startDate' || key === 'endDate') {
        if (value && typeof value === 'string') {
          formData.append(key, new Date(value).toISOString());
        } else if (value) {
          formData.append(key, value);
        }
      }
      else if (key === 'stockNotificationsRecipients') {
        if (Array.isArray(value)) {
          value.forEach((recipient, index) => {
            formData.append(`${key}[${index}][full_name]`, recipient.full_name);
            formData.append(`${key}[${index}][email]`, recipient.email);
            if (recipient.designation) {
              formData.append(`${key}[${index}][designation]`, recipient.designation);
            }
          });
        }
      }
      else if (value !== null && value !== undefined) {
        formData.append(key, value);
      }
    }

    const response = yield axios.patch(
      `${baseURL}/lab-setup/${labId}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    if (response.status === 200) {
      AntdAlert.success("Lab updated successfully");
      yield put(actions.updateLabSuccess(response.data));
    } else if (response.status !== 200) {
      AntdAlert.error("Something went wrong!");
      yield put(actions.updateLabError());
      errorHandler(response.data);
    }
  } catch (error) {
    console.log(error);
    yield put(actions.updateLabError());
  }
}

export function* handleFetchLabDetailsUtils() {
  try {
    const response = yield axios.get(`${baseURL}/api/v1/users/user_details`);
    const { success } = response.data;

    if (success) {
      yield put(actions.fetchLabDetailsUtilsSuccess(response.data.data));
    }
    errorHandler(response.data);
  } catch (error) {
    console.log(error);
  }
}

export function* handleFetchAllLabs({ data }) {
  const { search, ...rest } = data;
  Object.keys(search).forEach((key) => {
    if (search[key]?.length < 1 || search[key] === null) delete search[key];
  });

  if (search && Array.isArray(search.status) && search.status.length > 0) {
    search.status = search.status.join(",");
  }

  try {
    const response = yield axios.get(`${baseURL}/lab-setup`, {
      params: {
        ...rest,
        ...(Object.keys(search).length > 0 && {
          ...search,
          // showByDefault: false,
        }),
      },
    });


    if (response.status === 200) {
      yield put(actions.fetchAllLabsSuccess(response.data));
    } else if (response.status !== 200) {
      errorHandler(response.data);
      yield put(actions.fetchAllLabsError(response.data));
    }
  } catch ({ response }) {
    yield put(actions.fetchAllLabsError(response.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}

export function* handleDeleteLab({ data }) {
  try {
    const response = yield axios.delete(
      `${baseURL}/lab-setup/${data.id}`
    );
    if (response.status === 200) {
      AntdAlert.success("Lab deleted successfully");
      yield put(actions.deleteLabSuccess(response.data));
    } else if (response.status !== 200) {
      errorHandler(response.data);
      yield put(actions.deleteLabError(response.data));
    }
  } catch ({ response }) {
    yield put(actions.deleteLabError(response.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}

export function* handleFetchLab({ data }) {
  try {
    const response = yield axios.get(`${baseURL}/lab-setup/${data}`);

    if (response.status === 200) {
      // const { permissions, ...res } = response.data.data;
      yield put(actions.fetchLabSuccess(response.data));
    } else {
      yield put(actions.updateLabError());
      errorHandler(response.data);
    }
  } catch (error) {
    console.log(error);
  }
}

export function* handleDeleteLabAttach({ data }) {
  try {
    const { labId, attachmentId } = data;

    if (!labId) {
      AntdAlert.error("Lab ID not found. Cannot delete attachment.");
      yield put(actions.deleteLabAttachError({ error: "Lab ID not found" }));
      return;
    }

    const response = yield axios.delete(
      `${baseURL}/lab-setup/${labId}/attachments/${attachmentId}`
    );


    if (response.status === 200) {
      AntdAlert.success("Attachment deleted successfully");
      yield put(actions.deleteLabAttachSuccess(response.data.data));
    } else if (response.status !== 200) {
      errorHandler(response.data);
      yield put(actions.deleteLabAttachError(response.data.data));
    }
  } catch ({ response }) {
    yield put(actions.deleteLabAttachError(response.data.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}

export function* handleDeleteStockNotificationRecipient({ data }) {
  try {
    const { labId, index } = data;

    if (!labId) {
      AntdAlert.error("Lab ID not found. Cannot delete recipient.");
      yield put(actions.deleteLabAttachError({ error: "Lab ID not found" }));
      return;
    }

    if (index === undefined || index === null) {
      AntdAlert.error("Recipient index not found. Cannot delete recipient.");
      yield put(actions.deleteStockNotificationRecipientError("Recipient index not found"));
      return;
    }

    const response = yield axios.delete(
      `${baseURL}/lab-setup/${labId}/recipients/${index}`
    );


    if (response.status === 200) {
      AntdAlert.success("Reciepient deleted successfully");
      yield put(actions.deleteStockNotificationRecipientSuccess(response.data.data));
      yield put(actions.fetchLab(labId));
    } else if (response.status !== 200) {
      errorHandler(response.data);
      yield put(actions.deleteStockNotificationRecipientError(response.data.data));
    }
  } catch ({ response }) {
    yield put(actions.deleteLabAttachError(response.data.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}

export function* handleUpdateLabNotifications({ data }) {
  try {
    const fd = new FormData();
    for (const [key, value] of Object.entries(data)) {
      if (value !== null && value !== undefined) {
        fd.append(key, value);
      }
    }
    const response = yield axios.put(
      `${baseURL}/api/v1/labs/${data.id}`,
      fd,
      {
        headers: {
          "content-type": "multipart/form-data",
        },
      }
    );
    const { success, message } = response.data;
    if (success) {
      AntdAlert.success(message);
      yield put(actions.updateLabNotificationsSuccess(response.data.data));
    } else if (!success) {
      AntdAlert.error(response.data?.errors[0]);
      yield put(actions.updateLabNotificationsError());
      errorHandler(response.data);
    }
  } catch (error) {
    console.log(error);
  }
}

export function* handleFetchLabUsers({ data }) {
  try {
    const response = yield axios.get(`${baseURL}/user-labs`, {
      params: {
        labSetupId: data,
      },
    });
    console.log('handleFetchLabUsers response:', response.data);

    if (response.status === 200) {
      yield put(actions.fetchLabUsersSuccess(response.data.UserLabSetups || []));
    } else {
      yield put(actions.fetchLabUsersError());
      errorHandler(response.data);
    }
  } catch (error) {
    console.log(error);
    yield put(actions.fetchLabUsersError());
  }
}

export function* handleFetchLabUsersMap({ data }) {
  try {
    const labIds = data;
    if (!labIds || labIds.length === 0) return;

    // Use Promise.all to fetch in parallel
    const responses = yield Promise.all(
      labIds.map(id => axios.get(`${baseURL}/user-labs`, {
        params: {
          labSetupId: id,
        },
      }))
    );

    const labUsersMap = {};
    responses.forEach((response, index) => {
      const labId = labIds[index];
      if (response.status === 200) {
        labUsersMap[labId] = response.data.UserLabSetups || [];
      } else {
        labUsersMap[labId] = [];
      }
    });

    yield put(actions.fetchLabUsersMapSuccess(labUsersMap));

  } catch (error) {
    console.log(error);
    yield put(actions.fetchLabUsersMapError());
  }
}

